import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";
import BrandLogo from "@/components/ui/BrandLogo.tsx";

function BrandHeader() {
    const { brandConfig } = useContext(OscarContext) as OscarContextType

    return (
        <div className="os-flex os-flex-col md:os-flex-row os-gap-4 os-w-full os-items-center os-app-row">
            <BrandLogo className="os-w-24 os-h-24"/>
            <div className="os-flex-1 os-text-center md:os-text-left">
                <div className="os-text-2xl os-w-full">{brandConfig?.name ?? ''} Booking</div>
                <div className={"os-w-full"}>Book a skip bin for delivery and pickup.</div>
            </div>
            <div className="os-flex os-flex-col md:os-items-end os-text-center md:os-text-left">
                <div>Have a question?</div>
                <div>
                    Call us on <a href={`tel:`+brandConfig?.phoneUrl} className="os-text-blue-500">{ brandConfig?.phone }</a>
                </div>
            </div>
        </div>
    );
}

export default BrandHeader